export function NoPermissionAccess() {
    return <h5>User don't have permission to access this page.</h5>
}